import React from 'react';
import CommentCard from './ComentCard.jsx';
import img1 from '../../img/schoolDate1.png'
import img2 from '../../img/schoolDate2.png'
import img3 from '../../img/schoolDate3.png'
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice'

const Heading = styled.h2`
    margin-bottom: 30px;
    padding: 15px;
    font-size: 24px;
    font-size: 1.5rem;
    background-color:#009d80;
    color: #fff;
    border-radius: 7px;
    margin-top: 50px;
`;

const MarginWid = styled.div`
    width: 80%;
    margin:0 auto;
    margin-bottom: 30px;
    border:2px solid #f5f5f5;
    border-radius: 3px;
    @media ${device.laptop}{
        width:100%;
     }
`;

const Messeage = styled.h4`color:rgb(0, 173, 128);`;
const Comment = () => {
    return (
        <>





            <p className="text">近年、普通科よりも「高知商業・高知工業・高知農業」の人気が高まっているのでは？　学科により差はあるが、その高校全体の募集人数に近い出願数が出ているからである。高知商業に至っては全学科募集人数２８０に対し、入試当日の受験者は３１１になり、全学科が倍率１倍を超えているのは驚き！でありB日程は当然無しである。</p>

            <p className="text">普通科を志望するのも良いが、少し専門性の高い高校にも視野を広げ、「自分の進むべき道」と照らし合わせながら選択するのも一つの方法ではないか。</p>

            <p className="text">受験生の皆さんは、年間を通じて自分の志望校の動向は常に把握しておいてください。</p>
            <p className="text">ライバルが増え倍率が上がっても「合格者」になるためには、<u>本番入試までに実力をつけるしかない。</u>残された時間を悔いのないように過ごして欲しい。</p>


            <Heading>進路選択のポイントは</Heading>
            <ul>
                <li>① その学校・学科は、どんな内容をどのように学習するのか？</li>
                <li>②その学校を卒業したらどんな学校に進学したり、どんな資格をとったり、どんな企業に就職しているのか？高校で行われる学校説明会、入学案内パンフレット、高校のホームページや部活の先輩の話などまで参考にして、まずは自分の将来から考えてみよう。そして、合格するには、進学への意欲をしっかりと持ち、早い時期から勉強すればいいんです。また、高校以降も困らない学力をつけることができるのも今だけだ。</li>
            </ul>
            <Heading>★来年度の公立高校入試に向けては</Heading>
            <ul>
                <li>①人気のある学校・学科はやはり難しい。それはその他の高校にも影響する。</li>
                <li>②入試問題が、思考力・判断力・表現力を問う問題、記述による解答を求める問題へとレベルアップしている。</li>
            </ul>
            <p className="text">
                受験生に人気のある学校・学科は、来春の入試も厳しいことは変わらない。第一志望が厳しいと判断されると、第二志望へと受験校を変更するので、地元の人気の高い順に難しくなる。一日も早く高校入試の現実を知り、自分自身の意識を高め、受験勉強に取り組み、志望する高校への合格をつかんでもらいたい。
            </p>

            <div className='mt-5 text-center'>
                <Messeage>高校入試は自分の実力を問われる真剣勝負です！</Messeage>
            </div>
            <Heading>参考資料　過去の統一模試志望者動向</Heading>
            <p>※受験者動向の大きく変化した3校、丸の内（普通）、高知商業（社会マネ）、高知工業（建築）の統一模試志願者数の推移を表した。本番入試では難しくなると予想されていた。</p>

            <CommentCard
                title={'【丸の内(普通)】　（定員：140名）'}
                text={'昨年度より志望者数は控えめだが、本番は164名が受験し、倍率も1.17倍になった。流石は人気の高校である。'}
                imgResult={img1}
            />
            <CommentCard
                title={'【高知商業(社会マネ)】　（定員：70名）'}
                text={'統一模試の最高志望者数は78名だったが、本番は90名が受験し、倍率は1.29倍の1位だった。'}
                imgResult={img2}
            />
            <CommentCard
                title={'【高知工業(建築)】　（定員：40名）'}
                text={'倍率は1.15倍になり、46名が受験した。統一模試では第2回から右肩上がりを続けていたので、倍率が高くなる事は予想出来ていた。他校でもある事ですが、模試の志望者数を本番は上回ってきます。「A判定が出たので・・・」は危険ですよ！'}
                imgResult={img3}
            />

        </>
    );
}

export default Comment;